export function isValidField(text: string, setValidStatus: (status: string) => void) {
  if (text?.length > 0) {
    setValidStatus('TRUE')
    return true
  } else {
    setValidStatus('IDLE')
    return false
  }
}